/* projects/shared/layouts/responsive-nav-bar/shared-sidebar-list/shared-sidebar-list-header/shared-sidebar-list-header.component.scss */
.shared-sidebar-title-cell {
  color: var(--color-primary-text);
  font-weight: bold;
  font-size: var(--font-xxs);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--space-s);
}
.shared-sidebar-title-cell .shared-sidebar-subtitle {
  padding-top: var(--space-xs);
  color: var(--color-primarty-text);
  opacity: var(--color-opacity-50);
  transform: scale(1);
  transition: transform 0.1s ease-in-out;
  transform-origin: 0 100%;
}
.shared-sidebar-title-cell .shared-sidebar-subtitle.pulse {
  transform: scale(1.1);
}
/*# sourceMappingURL=shared-sidebar-list-header.component-RQBBNXC3.css.map */
